/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const howItWorksLandingConfig = {
  title: 'How it works',
  description:
    "This insurance is unlike any other you've encountered before, with unparalleled simplicity and transparency",
  features: [
    {
      title: 'Create a policy in a matter of minutes',
      description:
        'Easily tailor your policy to your specific requirements, all from the convenience of your own home',
      icon: 'https://i.ibb.co/pLYD5sZ/laptop-icon-bli-500.png',
    },
    {
      title: 'Track unprecedented event by utilizing government civil data',
      description:
        'Designed to provide financial protection and support to the loved ones left behind',
      icon: 'https://i.ibb.co/Hz9cc32/human-icon.jpg',
    },
    {
      title: 'Automated payouts made simple',
      description:
        'In the event of a detected incident, we will proactively initiate your claim to your nominee(s)',
      icon: 'https://i.ibb.co/F6gJ5KW/piggybank-icon-bli-500.png',
    },
  ],
};
